"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import { useRequestsModel } from "./requestsPageModel";
import RequestsToolbar from "./_cmp/RequestsToolbar";
import RequestList from "./_cmp/RequestList";
import RequestListSkeleton from "./_cmp/RequestListSkeleton";
import RequestViewDialog from "./_cmp/RequestViewDialog";
import { Inbox } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function RequestsPage() {
  const {
    filteredRequests,
    isLoading,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    formTypeFilter,
    setFormTypeFilter,
    selectedRequest,
    openRequest,
    closeRequest,
    handleUpdateStatus,
  } = useRequestsModel();
  const isMobile = useIsMobile();

  const list = isLoading ? (
    <RequestListSkeleton />
  ) : (
    <RequestList requests={filteredRequests} onView={openRequest} onUpdateStatus={handleUpdateStatus} />
  );

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 border-b border-border bg-card/80 px-3 py-2 backdrop-blur-sm">
            <PageHeader
              title="Requests"
              icon={Inbox}
              subtitle={`${filteredRequests.length} requests`}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            <RequestsToolbar
              search={search}
              onSearchChange={setSearch}
              statusFilter={statusFilter}
              onStatusFilterChange={setStatusFilter}
              formTypeFilter={formTypeFilter}
              onFormTypeFilterChange={setFormTypeFilter}
            />
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>

        <RequestViewDialog
          request={selectedRequest}
          onClose={closeRequest}
          onUpdateStatus={handleUpdateStatus}
        />
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Requests"
          icon={Inbox}
          subtitle={`${filteredRequests.length} requests`}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-5 py-5">
          <RequestsToolbar
            search={search}
            onSearchChange={setSearch}
            statusFilter={statusFilter}
            onStatusFilterChange={setStatusFilter}
            formTypeFilter={formTypeFilter}
            onFormTypeFilterChange={setFormTypeFilter}
          />

          <div className="flex min-h-0 flex-1 flex-col">{list}</div>
        </div>
      </div>

      <RequestViewDialog
        request={selectedRequest}
        onClose={closeRequest}
        onUpdateStatus={handleUpdateStatus}
      />
    </PageContainer>
  );
}
